import { __assign, __awaiter, __generator } from "tslib";
import { HttpClient } from '@wix/http-client';
import { embeddedScriptAppStatus, } from '../components/manage-installed-apps-page';
import { isEmbeddedScriptApp } from '../utils/appUtils';
import { filterBusinessSolutionApps, filterDismissedBundleApps } from '..';
// const mock = require('../../dev/installed-apps-mock.json');
var httpClient = new HttpClient();
var solutionLimit = 200;
export var getTagsDataBySlugs = function (baseApiUrl, slugs, locale, countryCode, sortTagsByGeo) {
    if (locale === void 0) { locale = 'en'; }
    var baseURl = 'marketplace-api/v1';
    var sortByGeo = sortTagsByGeo && countryCode ? "&order=GEO&country=" + countryCode : '';
    var url = baseApiUrl + "/_api/" + baseURl + "/web-solutions/tags/" + slugs.join(',') + "?limit=" + solutionLimit + "&lang=" + locale + sortByGeo;
    return httpClient.get(url).then(function (_a) {
        var data = _a.data;
        return data;
    });
};
export var fetchInstalledApps = function (baseUrl, signedInstance, local, hideBusinessSolutions) {
    if (signedInstance) {
        return httpClient
            .get(baseUrl + "/_api/marketplace-api/v1/managed-apps?lang=" + local, {
            headers: { Authorization: signedInstance },
            withCredentials: true,
        })
            .then(function (res) {
            var _a;
            var apps = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.managedWebSolutions) || [];
            var appsWithBase = apps.filter(function (app) { return app.webSolutionBase; });
            if (hideBusinessSolutions) {
                return filterBusinessSolutionApps(appsWithBase);
            }
            return appsWithBase;
        })
            .catch(function (error) { return console.log('cannot fetch installed apps', error); });
    }
    return Promise.resolve([]);
};
export var fetchBundleApps = function (baseUrl, signedInstance, local, geo) {
    if (signedInstance) {
        var geoString = geo ? "&geo=" + geo : '';
        return httpClient
            .get(baseUrl + "/_api/marketplace-api/v1/bundle-apps?lang=" + local + "&number_of_days=30" + geoString, {
            headers: { Authorization: signedInstance },
            withCredentials: true,
        })
            .then(function (res) {
            return res &&
                res.data &&
                filterDismissedBundleApps(res.data.bundleWebSolutions);
        })
            .catch(function (error) {
            console.log('cannot fetch bundle apps', error);
            return Promise.resolve([]);
        });
    }
    return Promise.resolve([]);
};
export var getPermittedActions = function (baseUrl, msid) {
    return httpClient
        .get(baseUrl + "/_serverless/app-market-rpc-proxy/market-actions/" + msid)
        .then(function (_a) {
        var data = _a.data;
        return data.body;
    })
        .catch(function (e) { return ['']; });
};
// The new delete app api, should replace the other delete app function after testing.
export var newDeleteApp = function (baseUrl, authorizationHeader, appDefId) {
    return httpClient
        .post(baseUrl + "/_api/site-apps/v1/site-apps/bulk-uninstall", {
        apps: [appDefId],
    }, { headers: { authorization: authorizationHeader } })
        .then(function (data) { return data; })
        .catch(function (e) { return console.log('cant delete app :('); });
};
export function postAppReview(review, appDefId, baseUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var uri;
        return __generator(this, function (_a) {
            uri = baseUrl + "/_api/reviews-server/v1/products/" + appDefId + "/reviews";
            return [2 /*return*/, httpClient
                    .post(uri, review)
                    .then(function (data) { return data; })
                    .catch(function (e) { return console.log('cant rate:('); })];
        });
    });
}
export var getReviewesBySolutionId = function (baseUrl, solutionId, sortMethod, offset, limit) {
    if (sortMethod === void 0) { sortMethod = '-publishedAt'; }
    if (offset === void 0) { offset = 0; }
    if (limit === void 0) { limit = 5; }
    return httpClient
        .get(baseUrl + "/_serverless/app-market-reviews/" + solutionId + "?sort=" + sortMethod + "&offset=" + offset + "&limit=" + limit, { withCredentials: true })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
export var setEmbeddedScriptAppActive = function (newStatus, signedInstance, appInstanceId, baseUrl, appStatus) { return __awaiter(void 0, void 0, void 0, function () {
    var properties;
    return __generator(this, function (_a) {
        properties = __assign({ parameters: appStatus.parameters }, { disabled: newStatus });
        return [2 /*return*/, httpClient.post(baseUrl + "/_api/app-instance-manager/v1/scripts/" + appInstanceId, { properties: properties }, {
                headers: { cookie: document.cookie, Authorization: signedInstance },
                withCredentials: true,
            })];
    });
}); };
export var getEmbeddedScriptAppStatus = function (signedInstance, appInstanceId, baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, httpClient.get(baseUrl + "/_api/app-instance-manager/v1/scripts/" + appInstanceId, {
                headers: { cookie: document.cookie, Authorization: signedInstance },
                withCredentials: true,
            })];
    });
}); };
export var getAllEmbeddedScriptAppsStatus = function (signedInstance, baseUrl, apps) {
    var embeddedApps = apps === null || apps === void 0 ? void 0 : apps.filter(isEmbeddedScriptApp);
    var promissArray = embeddedApps === null || embeddedApps === void 0 ? void 0 : embeddedApps.map(function (app) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getEmbeddedScriptAppStatus(signedInstance, app.instanceId, baseUrl)
                    .then(function (result) { return (__assign(__assign({}, app), { parameters: result.data.properties.parameters, status: result.data.properties.disabled
                        ? embeddedScriptAppStatus.DISABLED
                        : embeddedScriptAppStatus.ENABLED })); })
                    .catch(function () { return (__assign(__assign({}, app), { status: embeddedScriptAppStatus.NO_STATUS })); })];
        });
    }); });
    return Promise.all(promissArray);
};
export var fetchSiteData = function (msid, baseUrl) {
    if (msid) {
        return httpClient
            .get(baseUrl + "/_serverless/app-market-rpc-proxy/premium-features/" + msid)
            .then(function (res) {
            var result = res.data.body || {};
            var premiumFeatures = (result && result.premiumFeatures) || [];
            var domains = (result && result.domains) || [];
            return {
                siteIsPremium: !!premiumFeatures.length,
                siteHasDomain: !!domains.length,
            };
        })
            .catch(function (error) {
            return {
                siteIsPremium: true,
                siteHasDomain: true,
            };
        });
    }
    return {
        siteIsPremium: true,
        siteHasDomain: true,
    };
};
export var cancelTestPlan = function (baseUrl, appId, vendorId, authorizationHeader) {
    return httpClient.put(baseUrl + "/_api/marketplace-api/v1/cancel-test-plan", { appId: appId, vendorId: vendorId }, {
        headers: { Authorization: authorizationHeader },
        withCredentials: true,
    });
};
export var fetchNewRecommendedApps = function (baseUrl, authorizationHeader, local) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, httpClient
                .get(baseUrl + "/_api/marketplace-api/v1/web-solutions/recommended?limit=4&lang=" + local, {
                headers: { Authorization: authorizationHeader },
                withCredentials: true,
            })
                .then(function (_a) {
                var data = _a.data;
                return data;
            })];
    });
}); };
export var getRecommendationsFromML = function (baseUrl, limit, lang, signedInstance) {
    if (signedInstance) {
        return httpClient
            .get(baseUrl + "/_api/marketplace-api/v1/web-solutions/app-market-recommender?limit=" + limit + "&lang=" + lang, { headers: { Authorization: signedInstance } })
            .then(function (_a) {
            var data = _a.data;
            return data || {};
        })
            .catch(function (error) { return console.log('cannot fetch ML apps', error); });
    }
    return Promise.resolve([]);
};
//# sourceMappingURL=api.js.map